module.exports = __webpack_public_path__ + "static/media/betting.1a79332b.svg";